import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { adminApi } from "@/lib/api";

export default function AdminGate({ children }) {
  const token = localStorage.getItem("nexon_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}
